<template>
  <div class="page-content">
    <div class="page-header">
      <div>
        <BreadcrumbComponent :items="items" />
        <h1 class="page-title">Ingrédients</h1>
        <p class="page-subtitle">{{ rows.length }} ingrédient{{ rows.length > 1 ? 's' : '' }}</p>
      </div>
      <div>
        <v-btn color="primary" depressed small @click="openCreate"><v-icon left small>mdi-plus</v-icon>Nouveau</v-btn>
      </div>
    </div>

    <PreloaderComponent :enable="enable" />

    <div v-if="enable">
      <div class="d-flex justify-end mb-3">
        <input v-model="search" type="text" placeholder="Rechercher..." class="search-input" />
      </div>

      <v-card flat class="table-card">
        <v-simple-table dense>
          <thead>
            <tr>
              <th class="text-left">NOM</th>
              <th class="text-left">UNITÉ</th>
              <th class="text-right">COÛT</th>
              <th class="text-right">ALERTE</th>
              <th class="text-center">STATUT</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in filteredRows" :key="r.id">
              <td class="text-left font-weight-medium">{{ r.name }}</td>
              <td class="text-left">{{ r.unit }}</td>
              <td class="text-right">{{ fmt(r.cost) }}</td>
              <td class="text-right">{{ fmt(r.stock_alert) }}</td>
              <td class="text-center">
                <v-chip x-small :color="r.status ? 'success' : 'error'" dark>{{ r.status ? 'Actif' : 'Inactif' }}</v-chip>
              </td>
              <td style="width: 50px;">
                <v-btn icon x-small @click="edit(r)"><v-icon small color="primary">mdi-pencil</v-icon></v-btn>
              </td>
            </tr>
            <tr v-if="filteredRows.length === 0">
              <td colspan="6" class="text-center text--secondary pa-6">Aucun ingrédient</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </div>

    <v-dialog v-model="dialog" max-width="520" @click:outside="close">
      <v-card class="dialog-card">
        <v-card-title class="dialog-title">
          <v-icon color="primary" size="18" class="mr-2">mdi-food-variant</v-icon>
          {{ form_title }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="dialog-body">
          <div class="form-group">
            <label class="form-label">Nom *</label>
            <v-text-field v-model="ingredient.name" outlined dense hide-details="auto"></v-text-field>
          </div>
          <v-row>
            <v-col cols="6">
              <div class="form-group">
                <label class="form-label">Unité *</label>
                <v-select v-model="ingredient.unit" :items="unitOptions" outlined dense hide-details></v-select>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="form-group">
                <label class="form-label">Coût</label>
                <v-text-field v-model.number="ingredient.cost" type="number" min="0" outlined dense hide-details></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <div class="form-group">
                <label class="form-label">Stock initial</label>
                <v-text-field
                  v-model.number="ingredient.stock"
                  type="number"
                  outlined
                  dense
                  hide-details
                  :disabled="!!ingredient.id"
                  :hint="ingredient.id ? 'Modifiable via les mouvements' : ''"
                  persistent-hint
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="form-group">
                <label class="form-label">Alerte stock</label>
                <v-text-field v-model.number="ingredient.stock_alert" type="number" min="0" outlined dense hide-details></v-text-field>
              </div>
            </v-col>
          </v-row>
          <div class="form-group">
            <v-switch v-model="ingredient.status" label="Actif" dense hide-details class="mt-0"></v-switch>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="close">Annuler</v-btn>
          <v-btn color="primary" depressed :loading="loading" :disabled="loading || !ingredient.name || !ingredient.unit" @click="save">Enregistrer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BreadcrumbComponent from '../components/BreadcrumbComponent.vue'
import PreloaderComponent from '../components/PreloaderComponent.vue'

export default {
  name: 'IngredientsView',
  components: { BreadcrumbComponent, PreloaderComponent },
  data: () => ({
    items: [{ text: 'Ingrédients', disabled: true, href: '/ingredients' }],
    enable: false,
    loading: false,
    dialog: false,
    search: '',
    rows: [],
    index: -1,
    form_title: 'Nouveau ingrédient',
    unitOptions: ['mg', 'g', 'kg', 't', 'lb', 'oz', 'ml', 'cl', 'dl', 'l', 'gal', 'qt', 'pt', 'floz', 'cup', 'tbsp', 'tsp', 'unité', 'paire', 'demi-douzaine', 'douzaine', 'centaine', 'millier'],
    ingredient: { name: '', unit: 'kg', cost: 0, stock: 0, stock_alert: 0, status: true },
  }),
  computed: {
    filteredRows() {
      if (!this.search.trim()) return this.rows
      var q = this.search.toLowerCase()
      return this.rows.filter(function (r) { return r.name && r.name.toLowerCase().indexOf(q) !== -1 })
    },
  },
  methods: {
    fmt(v) { var n = parseFloat(v); if (!n && n !== 0) return '0'; return Number.isInteger(n) ? String(n) : n.toFixed(2) },
    load() {
      var self = this
      this.$axios.get('/ingredients?orderasc=name')
        .then(function (r) { self.rows = r.data; self.enable = true })
        .catch(function () { self.enable = true })
    },
    openCreate() { this.reset(); this.form_title = 'Nouveau ingrédient'; this.dialog = true },
    edit(r) { this.index = this.rows.indexOf(r); this.ingredient = Object.assign({}, r); this.form_title = 'Modifier : ' + r.name; this.dialog = true },
    save() {
      var self = this; this.loading = true
      var payload = encodeURIComponent(JSON.stringify(this.ingredient))
      var req = this.ingredient.id
        ? this.$axios.put('/ingredients/' + this.ingredient.id + '?data=' + payload)
        : this.$axios.post('/ingredients?data=' + payload)
      req.then(function (r) {
        if (self.ingredient.id) { Object.assign(self.rows[self.index], r.data) } else { self.rows.unshift(r.data) }
        self.dialog = false; self.loading = false; self.reset()
      }).catch(function () { self.loading = false })
    },
    close() { this.dialog = false; this.reset(); this.loading = false },
    reset() { this.ingredient = { name: '', unit: 'kg', cost: 0, stock: 0, stock_alert: 0, status: true }; this.index = -1 },
  },
  mounted() { this.load() },
}
</script>

<style scoped>
.search-input { width: 260px; padding: 8px 12px; font-size: 0.8125rem; border: 1px solid #cbd5e1; border-radius: 6px; outline: none; color: #1a2332; background: #fff; }
.search-input:focus { border-color: #194173; box-shadow: 0 0 0 2px rgba(25, 65, 115, 0.1); }
.table-card { border: 1px solid #e8ecf1 !important; border-radius: 8px !important; overflow: hidden; }
.table-card .v-simple-table thead th { font-size: 0.6875rem !important; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; color: #94a3b8 !important; padding: 8px 16px !important; }
.table-card .v-simple-table tbody td { font-size: 0.8125rem; padding: 10px 16px !important; }
.dialog-card { border-radius: 12px !important; }
.dialog-title { font-size: 0.9375rem !important; font-weight: 600 !important; padding: 14px 20px 12px !important; }
.dialog-body { padding: 20px 20px 8px !important; }
.dialog-actions { padding: 8px 16px 12px !important; }
.form-group { margin-bottom: 16px; }
.form-label { display: block; font-size: 0.75rem; font-weight: 600; color: #475569; margin-bottom: 4px; }
</style>
